export default "__VITE_ASSET__ebfa351c__"